import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs-compat';

export class ImpExpTreeNode {
    name: string;
    fullPath: string;
    level: number;
    expandable: boolean;
    children: ImpExpTreeNode[];
}
//#region utilities for tree
/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {

    TREE_DATA: any[] = [];
    dataChange = new BehaviorSubject<ImpExpTreeNode[]>([]);
    decodeLevelNr = -1; // nr livello da impostare esternamente per decodificare dalla stringa i nomi applicazione e modulo

    get data(): ImpExpTreeNode[] {
        return this.dataChange.value;
    }

    constructor() {
        this.initialize();
    }

    async initialize() {
        // Build the tree nodes from Json object. The result is a list of `ImpExpTreeNode` with nested
        //     file node as children.
        const data = this.buildFileTree(this.TREE_DATA, 0);

        // Notify the change.
        this.dataChange.next(data);
    }

    /**
     * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
     * The return value is the list of `ImpExpTreeNode`.
     */
    buildFileTree(obj: { [key: string]: any }, level: number): ImpExpTreeNode[] {
        return Object.keys(obj).reduce<ImpExpTreeNode[]>((accumulator, key) => {
            const value = obj[key];
            const node = new ImpExpTreeNode();
            node.level = level;

            if (obj[key].name !== null && obj[key].name !== undefined)
                node.name = obj[key].name;
            else
                node.name = key;

            if (value != null) {
                if (typeof value === 'object') {
                    node.children = this.buildFileTree(value, level + 1);
                }
                else {
                  if (this.decodeLevelNr != -1 && level == this.decodeLevelNr) {
                      // has been specified the level nr. with value from which to extract the file name
                      node.fullPath = value;
                      let fileName = value.replace(/^.*[\\\/]/, '');

                      // gestione file Append da arricchire con le info di app+modulo di origine
                      if (fileName.toLowerCase().endsWith("append.xml")) {
                          // sample path
                          // C:\DevCloud\Standard\TaskBuilder\Framework\TbResourcesMng\DataManager\Default\IT\Professional\Basic\RM_Calendars.xml
                          // split per // (se sono Windows) oppure \\ se non li trova e quindi sono Linux
                          // cerco l'indice della standard per recuperare poi il nome di applicazione e modulo
                          let segments = node.fullPath.split("\\");
                          if (segments.length === 1)
                              segments = node.fullPath.split("//");

                          let idxStdFolder = segments.findIndex(s => s.toLowerCase() === "standard");
                          if (idxStdFolder > 0) {
                              let appName = '';
                              let moduleName = '';

                              for (let index = idxStdFolder + 2; index < segments.length; index++) {
                                  if (appName === '') {
                                      appName = segments[index];
                                      continue;
                                  }
                                  if (moduleName === '') {
                                      moduleName = segments[index];
                                      continue;
                                  }
                                  if (appName !== '' && moduleName !== '')
                                      break;
                              }

                              node.name = fileName + ' (' + appName + ' - ' + moduleName + ')';
                          }
                          else
                              node.name = value; //
                      }
                      else
                          node.name = fileName;
                  } else {
                      node.name = value;
                  }
                }
            }

            return accumulator.concat(node);
        }, []);
    }

    public filter(filterText: string, TREE_DATA_local: any[]) {
        let filteredTreeData;
        if (filterText) {
            console.log(TREE_DATA_local);
            filteredTreeData = TREE_DATA_local.filter(
                (d) => d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1
                // && d.level === 2
            );
            Object.assign([], filteredTreeData).forEach((ftd) => {
                let str = <string>ftd.name;
                while (str.lastIndexOf('.') > -1) {
                    const index = str.lastIndexOf('.');
                    str = str.substring(0, index);
                    if (filteredTreeData.findIndex((t) => t.name === str) === -1) {
                        const obj = TREE_DATA_local.find((d) => d.name === str);
                        if (obj) {
                            filteredTreeData.push(obj);
                        }
                    }
                }
            });
        } else {
            filteredTreeData = TREE_DATA_local;
        }

        // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
        // file node as children.
        const data = this.buildFileTree(filteredTreeData, 0);
        // Notify the change.
        this.dataChange.next(data);
    }

    /** Add an item to to-do list */
    insertItem(parent: ImpExpTreeNode, name: string) {
        if (parent.children) {
            parent.children.push({ name: name } as ImpExpTreeNode);
            this.dataChange.next(this.data);
        }
    }

    updateItem(node: ImpExpTreeNode, name: string) {
        node.name = name;
        this.dataChange.next(this.data);
    }
}
//#endregion
